import React from 'react';
import './Spinner.css';

export const Spinner = ({ size = 'md', fullScreen = false }) => {
  const spinner = <div className={`ui-spinner ui-spinner-${size}`} />;

  if (fullScreen) {
    return <div className="ui-spinner-fullscreen">{spinner}</div>;
  }

  return spinner;
};

export default Spinner;
